import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=25e87f11&scoped=true"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadBtn.vue?vue&type=style&index=0&id=25e87f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e87f11",
  null
  
)

export default component.exports